import { render, staticRenderFns } from "./StepikSection.vue?vue&type=template&id=1af706da"
import script from "./StepikSection.vue?vue&type=script&lang=js"
export * from "./StepikSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports